// src/utils/sanitizeInput.ts
// Utilidad para sanitizar entradas de usuario y prevenir XSS/content spoofing

/**
 * Elimina etiquetas HTML peligrosas y entidades script de un string.
 * Puedes mejorar esto usando una librería como DOMPurify si el proyecto lo permite.
 */
export function sanitizeInput(input: string): string {
  // Elimina etiquetas script y html básicas
  return input
    .replace(/<script.*?>.*?<\/script>/gi, '')
    .replace(/<.*?>/g, '')
    .replace(/javascript:/gi, '')
    .replace(/on\w+=/gi, '');
}
